// const moment = require('moment')
import { searchInfoByPn } from '@/api/announceApi.js'
const industryList = require('@/utils/industryList')
const requestCols = [
  { alias: 'title' },
  { alias: 'last_legal_status' },
  { alias: 'application_num' },
  { alias: 'patent_status' },
  { alias: 'patent_type' }
]

export const _formRows = [
  {
    span: 24,
    label: '公开(公告)号',
    component: 'AInputAndButton',
    prop: 'publicNum',
    placeholder: '请输入公开(公告)号',
    allowClear: true,
    tips: '温馨提示：输入公开号，点击”查询“，系统可自动获取公开号相关专利信息',
    styleTips: {
      color: '#f83f41',
      marginTop: '3px'
    },
    btnOpt: {
      title: '查询',
      btnClass: 'WxInputAndBtn',
      customOperation: async function(instance) {
        if (instance.defaultValue === '') {
          this.$message.warning('请输入公开(公共)号!')
          return
        }
        try {
          this.loading = true
          const pn = instance.defaultValue // 公开号 CN107539481A
          // 请求
          const result = await searchInfoByPn(pn, requestCols)
          const data = JSON.parse(result.data)
          let params = {}
          if (data.result.length > 0) {
            // 处理结果
            const {
              title,
              last_legal_status,
              application_num,
              patent_type
            } = data.result[0]
            params = {
              patentName: title || '-',
              legalStatus: Array.isArray(last_legal_status)
                ? last_legal_status.join(',')
                : last_legal_status || '-',
              applyNum: application_num || '-'
            }
            let patentType = [
              { label: '发明专利', value: '0' },
              { label: '实用新型', value: '1' },
              { label: '外观设计', value: '2' },
              { label: '其他', value: '3' }
            ]
            // 单独处理专利类型
            if (patent_type) {
              const label = ['发明', '发明申请', '发明授权'].includes(
                patent_type
              )
                ? '发明专利'
                : patent_type
              const v = patentType.find(l => l.label === label).value
              params.patentType = v
            }
            this.$apiStatusHandler(200, '查询成功')
          } else {
            this.$apiStatusHandler(20, '暂无查询到相关信息')
          }
          this.$emit('updateForm', params)
        } catch (error) {
          this.$apiStatusHandler(99, error.message)
        } finally {
          this.loading = false
        }
      }
    }
  },
  {
    span: 12,
    label: '申请号',
    component: 'AInput',
    placeholder: '请输入申请号',
    prop: 'applyNum',
    allowClear: true
  },
  {
    span: 12,
    label: '专利名称',
    component: 'AInput',
    placeholder: '请输入专利名称',
    prop: 'patentName',
    allowClear: true
  },
  {
    span: 12,
    label: '法律状态',
    component: 'AInput',
    placeholder: '请输入法律状态',
    prop: 'legalStatus',
    allowClear: true
  },
  {
    span: 12,
    label: '专利类型',
    component: 'ASelect',
    placeholder: '请输入专利类型',
    prop: 'patentType',
    allowClear: true,
    list: [
      { label: '发明专利', value: '0' },
      { label: '实用新型', value: '1' },
      { label: '外观设计', value: '2' },
      { label: '其他', value: '3' }
    ]
  },
  {
    span: 12,
    label: '产业分类',
    component: 'ASelect',
    placeholder: '请输入产业分类',
    prop: 'industry',
    allowClear: true,
    list: industryList.industryList
  },
  {
    span: 24,
    label: '运营类型',
    component: 'ARadioGroup',
    prop: 'operationType',
    radioList: [
      { label: '待转化', value: '0' },
      { label: '许可', value: '1' },
      { label: '质押', value: '2' },
      { label: '转让', value: '3' }
    ]
  },
  {
    span: 24,
    label: '价格预算',
    component: 'ARadioGroup',
    prop: 'priceRange',
    disabledItem: ['selfRadio'],
    customSetDefault: true, // 特殊处理自定义输入框的默认值
    radioList: [
      // { label: '1万以下', value: '10000' },
      // { label: '1-10万', value: '1-100000' },
      // { label: '10-50万', value: '100000-500000' },
      // { label: '50-100万', value: '500000-1000000' },
      // { label: '100万以上', value: '1000001' },
      { label: '面议', value: -1 },
      {
        label: '自定义',
        isSelf: true,
        style: {
          width: '100px',
          marginTop: '10px'
        },
        inputValue: 0, // 输入框的值
        allowClear: true,
        key: 'selfRadio',
        value: 'selfRadio',
        disabled: true,
        placeholder: '请输入金额'
      }
    ],
    handleCustomResult(instance) {
      if (instance && instance.defaultValue) {
        if (instance.defaultValue !== -1) {
          instance.inputValue =
            this.defaultValue === 'selfRadio'
              ? this.radioInputValue
              : this.defaultValue
          instance.defaultValue = 'selfRadio'
          const t = instance.radioList.find(t => t.label === '自定义')
          t.disabled = false
        }
      }
    }
  },
  {
    span: 24,
    label: '成果介绍',
    component: 'ATextArea',
    placeholder: '请输入介绍内容',
    prop: 'describe',
    style: {
      height: '78px'
    },
    row: 5,
    allowClear: true
  },
  {
    span: 24,
    label: '科研团队',
    component: 'ATextArea',
    placeholder: '请输入科研团队内容',
    prop: 'team',
    style: {
      height: '78px'
    },
    row: 5,
    allowClear: true
  }
]

export const _formRules = {
  patentName: [
    { required: true, message: '专利名称不能为空', trigger: 'blur' }
  ],
  legalStatus: [
    { required: true, message: '法律状态不能为空', trigger: ['blur'] }
  ],
  applyNum: [{ required: true, message: '申请号不能为空', trigger: ['blur'] }],
  publicNum: [
    { required: true, message: '公开(公告)号不能为空', trigger: ['blur'] }
  ],
  operationType: [
    { required: true, message: '运营类型不能为空', trigger: ['blur'] }
  ],
  patentType: [
    { required: true, message: '专利类型不能为空', trigger: ['blur'] }
  ],
  describe: [
    { required: true, message: '成果介绍不能为空', trigger: ['blur'] }
  ],
  priceRange: [{ required: true, message: '预算不能为空', trigger: ['blur'] }],
  team: [{ required: true, message: '科研团队不能为空', trigger: ['blur'] }],
  industry: [{ required: true, message: '产业分类不能为空', trigger: ['blur'] }]
}

const _formInfo = [
  { label: '专利名称', value: '-', key: 'patentName' },
  { label: '法律状态', value: '-', key: 'legalStatus' },
  { label: '申请号', value: '-', key: 'applyNum' },
  { label: '公开(公告)号', value: '-', key: 'publicNum' },
  { label: '专利类型', value: '-', key: 'patentTypeStr' },
  { label: '产业分类', value: '-', key: 'industryListStr' },
  { label: '运营类型', value: '-', key: 'operationTypeStr' },
  { label: '价格预算', value: '-', key: 'priceRange' },
  { label: '成果介绍', value: '-', key: 'describe', isVHtml: true },
  { label: '科研团队', value: '-', key: 'team', isVHtml: true }
]

export const userInfo = [
  { label: '发布人', value: '-', key: 'userName' },
  { label: '机构名称', value: '-', key: 'enpName' },
  {
    label: '机构类型',
    value: '',
    key: 'orgTypeStr',
    isSelect: true,
    selectList: [
      { label: '高校院所', value: '0' },
      { label: '科研单位', value: '1' },
      { label: '国企单位', value: '2' }
    ]
  },
  { label: '手机', value: '-', key: 'phoneNumber' },
  { label: '电话', value: '-', key: 'enpPhone' },
  { label: '邮箱', value: '-', key: 'email' }
]

const filterFormRows = (list) => {
  if(process.env.VUE_APP_KEY === 'SzTech') {
    return list.filter(i => i.label !== '产业分类')
  }
  return list
}

const filterFormRule = (obj) => {
  if(process.env.VUE_APP_KEY === 'SzTech') {
    delete obj.industry
  }
  return obj
}

export const formInfo = filterFormRows(_formInfo)
export const formRows = filterFormRows(_formRows)
export const formRules = filterFormRule(_formRules)

// module.exports = {
//   formRows,
//   formRules,
//   formInfo,
//   userInfo
// }
